import React from 'react';
import { DynamicComponents } from '@lib/dynamicComponents';
import Blogs from '@components/Blogs';
import { graphql } from 'gatsby';
import { Content } from '@identity/wrappers';
import { Wrapper } from './styles';

export default ({ data }) => {
  const blogData = data.contentfulBlogPost;

  return (
    <Content>
      <Wrapper space={{ margin: { default: 'top-lg', desktop: 'top-xl' } }}>
        <Blogs hero title={blogData.title} noLink />
        {blogData.content.map(
          blog => (
            console.log(blog), (<DynamicComponents {...blog} key={blog.id} />)
          ),
        )}
      </Wrapper>
    </Content>
  );
};

export const query = graphql`
  query($slug: String!) {
    contentfulBlogPost(slug: { eq: $slug }) {
      title
      description {
        description
      }
      slug
      content {
        __typename
        ...SectionText
        ...Image
      }
    }
  }
`;
